<app-header-user></app-header-user>

<div class="ptb-70">
    <div class="container">
        <!-- Info box -->
        <div class="single-events-box mb-40">
            <div class="events-box">
                <div class="events-image d-none d-md-block">
                    <div class="image">
                        <i class="bx bx-calendar-check pIcon"></i>
                    </div>
                </div>

                <div class="events-content">
                    <div class="content">
                        <h5>Cum vă puteți programa</h5>

                        <!-- Analize cu plată -->
                        <h6 class="mt-2 text-primary">
                            Analize cu plată (Laborator)
                        </h6>
                        <ul class="list-unstyled mb-2">
                            <li>
                                <strong>Pașii de urmat:</strong>
                            </li>
                            <li>
                                – Programare cu plată →
                                <strong>Laborator</strong> →
                                <strong>Perioada de căutare</strong> →
                                <strong>Programează-te</strong>.
                            </li>
                            <li class="mt-1">
                                Momentan, recoltarea analizelor se efectueaza
                                doar cu plată. Secțiunea Încarcă
                                document(opțional) se folosește doar pentru
                                situația in care aveți o poză cu analizele
                                recomandate de medic sau un bilet de trimitere
                                care poate sprijini procesul de efectuare a
                                analizelor în cadrul spitalului
                            </li>
                            <li class="mt-1">
                                Veți fi contactat telefonic de către spital
                                pentru: pregătirea necesară anumitor analize sau
                                pentru situațiile în care nu putem efectua una
                                dintre analizele de pe biletul atașat la
                                programare.
                            </li>
                        </ul>

                        <!-- Ambulator fără plată -->
                        <h6 class="mt-3 text-success">Ambulator fără plată</h6>
                        <ul class="list-unstyled mb-0">
                            <li>
                                <strong>Condiție:</strong> aveți un bilet de
                                trimitere valid.
                            </li>
                            <li>
                                Vă rugăm să introduceți biletul în secțiunea
                                <a routerLink="/biletele-mele"
                                    ><strong>Bilete de trimitere</strong></a
                                >, apoi urmați pașii:
                            </li>
                            <li>
                                – Programare fără plată →
                                <strong
                                    >Specialitatea din ambulator dorită</strong
                                >
                                → <strong>Bilet de trimitere</strong> →
                                <strong>Perioada de căutare</strong> →
                                <strong>Programează-te</strong>.
                            </li>
                            <li class="mt-1">
                                În secțiunea
                                <a routerLink="/biletele-mele"
                                    ><strong>Bilete de trimitere</strong></a
                                >
                                veți putea vedea numărul de programări rămase pe
                                bilet și intervalul în care îl puteți folosi.
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="events-date">
                    <a routerLink="/biletele-mele" class="date">
                        <div class="d-table">
                            <div class="d-table-cell">
                                <h3>Biletele mele</h3>
                                <i class="bx bx-file-find"></i>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <!-- Zona de selecții principale -->
        <div class="row g-3 newProg">
            <!-- Tip programare -->
            <div class="col-xxl-3 col-lg-4 col-md-6">
                <div
                    class="progBox"
                    [class.active]="appointment.appoinmentType"
                >
                    <div class="form-group">
                        <label>
                            Tip programare <span class="text-danger">*</span>
                        </label>
                        <ng-select
                            [items]="appointmentTypes"
                            bindLabel="name"
                            bindValue="value"
                            placeholder="Cu plata, Fara plata"
                            [(ngModel)]="appointment.appoinmentType"
                            name="appointmentType"
                            (change)="onAppointmentTypeChange()"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <!-- Specialitate -->
            <div class="col-xxl-3 col-lg-4 col-md-6">
                <div class="progBox" [class.active]="appointment.specialtyCode">
                    <div class="form-group">
                        <label>
                            Specialitate <span class="text-danger">*</span>
                        </label>
                        <ng-select
                            [items]="filteredSpecialties"
                            bindLabel="name"
                            bindValue="code"
                            placeholder="Alege specialitatea"
                            [(ngModel)]="appointment.specialtyCode"
                            name="specialtyCode"
                            (change)="loadDoctors($event)"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <!-- Medic -->
            <div class="col-xxl-3 col-lg-4 col-md-6">
                <div class="progBox" [class.active]="appointment.doctorCode">
                    <div class="form-group">
                        <label>
                            Medic <span class="text-danger">*</span>
                        </label>
                        <ng-select
                            [items]="doctors"
                            bindLabel="name"
                            bindValue="code"
                            placeholder="Alege medicul"
                            [(ngModel)]="appointment.doctorCode"
                            name="doctorCode"
                            [disabled]="!isValid"
                            (change)="onDoctorChange()"
                        ></ng-select>
                    </div>
                </div>
            </div>

            <!-- Bilet de trimitere -->
            <div class="col-xxl-3 col-lg-4 col-md-6">
                <div class="progBox" [class.active]="appointment.ticketCode" *ngIf="appointment.appoinmentType == 0">
                    <div class="form-group" *ngIf="ticketsFound">
                        <label>
                            Bilet de trimitere
                            <span class="text-danger" *ngIf="!isPaid">*</span>
                        </label>

                        <ng-select
                            [items]="tickets"
                            bindLabel="displayLabel"
                            placeholder="Selectează biletul de trimitere"
                            [(ngModel)]="appointment.ticketCode"
                            name="ticketCode"
                            [disabled]="
                                !appointment.specialtyCode ||
                                !appointment.doctorCode
                            "
                            (change)="onTicketChange($event)"
                        >
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.batch }} | {{ item.number }} |
                                {{ item.isExternal ? "Extern" : "Intern" }}
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item">
                                <span>
                                    {{ item.batch }} | {{ item.number }} |
                                    <strong
                                        [class.text-warning]="item.isExternal"
                                        [class.text-primary]="!item.isExternal"
                                    >
                                        {{
                                            item.isExternal
                                                ? "Extern"
                                                : "Intern"
                                        }}
                                    </strong>
                                </span>
                            </ng-template>
                        </ng-select>
                    </div>

                    <div class="alert alert-info mb-0" *ngIf="isAvailbe">
                        {{ message }}
                    </div>

                    <div
                        class="alert alert-info mb-0"
                        *ngIf="!ticketsFound && appointment.appoinmentType == 0"
                    >
                        Nu aveți niciun bilet de trimitere pentru specialitatea
                        selectată (obligatoriu pentru programare fără plată).
                    </div>

                    <div
                        class="alert alert-info mb-0"
                        *ngIf="!ticketsFound && appointment.appoinmentType == 1"
                    >
                        Nu aveți niciun bilet de trimitere pentru specialitatea
                        selectată (opțional pentru programare cu plată).
                    </div>
                </div>
            </div>

            <!-- Comentariu pentru medic -->
            <div class="col-xxl-3 col-lg-4 col-md-6">
                <div class="progBox">
                    <div class="form-group">
                        <label>Comentariu pentru medic</label>
                        <textarea
                            class="form-control"
                            rows="4"
                            [(ngModel)]="appointment.participantComment"
                            name="participantComment"
                            placeholder="Scrie un mesaj pentru medic (opțional)"
                        >
                        </textarea>
                    </div>
                </div>
            </div>

            <!-- Încărcare document (opțional) -->

            <div
                class="col-xxl-3 col-lg-4 col-md-6"
                *ngIf="
                    !(
                        appointment.appoinmentType === '0' &&
                        appointment.specialtyCode === 'LB'
                    )
                "
            >
               <div *ngIf="!(isAddingFile === false && appointment.appoinmentType == '0')">
                    <div class="progBox">
                        <div class="form-group">
                            <label>Încarcă document (opțional)</label>
                            <input
                                type="file"
                                class="form-control"
                                (change)="onFileSelected($event)"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- Perioada de căutare -->
            <div class="col-xl-4 col-md-7">
                <div class="progBox active">
                    <label>
                        <i class="bx bx-calendar"></i> Perioada de căutare
                        <span class="text-danger">*</span>
                    </label>
                    <div class="row g-2">
                        <div class="col-6 form-floating">
                            <input
                                type="date"
                                class="form-control"
                                id="dStart"
                                ngbDatepicker
                                #d1="ngbDatepicker"
                                (click)="d1.toggle()"
                                [(ngModel)]="appointment.startDate"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                name="startDate"
                            />
                            <label for="dStart">Data start</label>
                        </div>
                        <div class="col-6 form-floating">
                            <input
                                type="date"
                                class="form-control"
                                id="dStop"
                                ngbDatepicker
                                #d2="ngbDatepicker"
                                (click)="d2.toggle()"
                                [(ngModel)]="appointment.endDate"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                name="endDate"
                            />
                            <label for="dStop">Data sfârșit</label>
                        </div>
                    </div>

                    <div class="text-center mt-3">
                        <button
                            type="button"
                            (click)="loadList()"
                            class="default-btn"
                        >
                            <i class="bx bx-search icon-arrow before"></i>
                            <span class="label">Caută disponibilitate</span>
                            <i class="bx bx-search icon-arrow after"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Lista disponibilități -->
        <div class="row mt-4" *ngIf="showList">
            <div class="col-md-12">
                <div class="progBox">
                    <h4 class="mb-3">
                        <i class="bx bx-time-five"></i> Intervalele disponibile
                    </h4>

                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th>Medic</th>
                                    <th>Data & ora</th>
                                    <th>Acțiune</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="loading">
                                <tr>
                                    <td
                                        colspan="3"
                                        class="text-center text-muted"
                                    >
                                        Lista se încarcă, vă rugăm așteptați...
                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="emptyList && !loading">
                                <tr>
                                    <td
                                        colspan="3"
                                        class="text-center text-muted"
                                    >
                                        Nu există disponibilitate pentru datele
                                        selectate.
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr *ngFor="let app of appointmentList">
                                    <td>{{ app.doctorname }}</td>
                                    <td>
                                        {{
                                            app.startDateTime
                                                | date: "dd.MM.yyyy HH:mm"
                                        }}
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            class="default-btn small-button"
                                            (click)="selectAppointment(app)"
                                        >
                                            <span>Programează-te</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
